import React from 'react';
import PropTypes from 'prop-types';

import { observer } from 'mobx-react';
import { observable } from 'mobx';

import { withNamespaces } from 'react-i18next';
import ReactCropper from 'react-cropper';
import { clientStore } from 'apps/client/app';

import { Wrapper, ButtonStyled } from './cropper.styled';

@withNamespaces()
@observer
class Cropper extends React.Component {
  @observable small = false;
  init = () => {
    // FIXME - Guard against some edge case bug where init is ran before ref is set
    if (this.cropperRef) {
      // FIXME - Remove this when adapting the mobile UI
      this.small = this.cropperRef.cropper.containerData.height < 200;
      this.cropperRef.moveTo(0, 0);
    }
    const { fieldStore } = this.props;
    fieldStore.getUpdate = this.update;
    if (!fieldStore.value) {
      this.update();
    }
  };

  update = callback => {
    const { fieldStore } = this.props;
    this.cropperRef.cropper.getCroppedCanvas().toBlob(blob => {
      const { fileAppManager } = fieldStore;
      const { file } = fileAppManager;
      const { uploader } = clientStore;
      const croppedFile = new File([blob], file.filename);
      uploader.FastTrackFile(
        fileAppManager,
        { fileObject: croppedFile },
        // FIXME - don't reuse file
        // eslint-disable-next-line
        file => {
          fieldStore.UpdateVal(file);
          callback();
        },
      );
    }, 'image/jpeg');
  };

  render() {
    const { removeFile, fieldStore, t } = this.props;
    const { fileAppManager, MarkFileModified } = fieldStore;
    return (
      <Wrapper>
        <ReactCropper
          ref={cropper => {
            if (!cropper) return;
            this.cropperRef = cropper;
          }}
          src={fileAppManager.file.src}
          ready={this.init}
          dragMode='move'
          className='cropper'
          cropBoxMovable={false}
          cropBoxResizable={false}
          toggleDragModeOnDblclick={false}
          minContainerWidth={100}
          autoCropArea={1}
          viewMode={3}
          guides={false}
          center={false}
          highlight={false}
          cropend={MarkFileModified}
          zoom={MarkFileModified}
          checkOrientation
          crossOrigin='anonymous'
        />

        <ButtonStyled
          text={!this.small ? t('Delete') : ''}
          variant='destructive'
          onClick={removeFile}
          customBgColor='#d14233'
          icon='delete'
        />
      </Wrapper>
    );
  }
}

export default Cropper;

Cropper.propTypes = {
  file: PropTypes.string,
  name: PropTypes.string,
  fieldStore: PropTypes.object,
  removeFile: PropTypes.func,
  updateForm: PropTypes.func,
  t: PropTypes.func,
};
